import { ThemeProvider, createTheme } from "@mui/material";
import React from "react";

const theme = createTheme({
  typography: {
    fontFamily: "Okra ,Helvetica ,sans-serif",
    button: {
      textTransform: "none",
    },
  },
});
const ThemeWrapper = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeWrapper;
